import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, ShareMessengerIcon } from '@paypalcorp/pp-react';

function SocialShareMessenger({ url, handleSocialLinkClick, linkTitle }) {
  return (
    <IconButton
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'messenger')}
      data-testid="social-share-messenger"
      size="sm"
      buttonType="secondary"
      svgIconComponent={ShareMessengerIcon}
    >
      {linkTitle}
    </IconButton>
  );
}

SocialShareMessenger.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.string,
};

export default SocialShareMessenger;
